/* A regex used to store page placeholder URLs inside {{..}} tags to mark the field that needs to be resolved with data
   from the detail page that is not scraped yet. When the detail is scraped, this value will be swapped with the values
   scraped from that page. */
const PLACEHOLDER_REGEX = /^{{(.*)}}$/

const SELECTOR_SEPARATOR_REGEX = /\s*>\s*/

// The user's role
const UserRole = {
    CLIENT: 'client',
    ADMIN: 'admin',
    DEMO: 'demo'
}

// Enum for defining a field's type
const FieldType = {
    TEXT: 'text',
    LINK: 'link',
    ATTRIBUTE: 'attribute',
    IMAGE: 'image',
    DETAIL_PAGE: 'page',
    FIXED: 'fixed'
}

// The nesting level of the page (top level or detail page)
const PageLevel = {
    TOP: 'top',
    DETAIL: 'detail'
}

// The export format
const ExportFormat = {
    CSV: 'csv',
    JSON: 'json',
    XLSX: 'xlsx'
}

// The request type
const RequestType = {
    NEXT_PAGE: 'next_page',
    DETAIL_PAGE: 'detail_page'
}

// Enumerates the supported pagination methods
const PaginationMethod = {
    NONE: 'none',
    NEXT_LINKS: 'next_links',
    SCROLL: 'scroll',
    LOAD_MORE: 'load_more',
}

// The scraper's status
const ScraperStatus = {

    // The scraper is idle (it's not running)
    IDLE: 'idle',

    // The scraper was triggered but it's not running yet
    STARTING: 'starting',

    // The scraper is running
    RUNNING: 'running',

    // Stopping the scraper was requested, but the scraper is not stopped yet
    STOPPING: 'stopping'
}

// The status of a scraper run
const ScraperRunStatus = {
    RUNNING: 'running',
    COMPLETED: 'completed',
    STOPPED: 'stopped',
    FAILED: 'failed'
}

// The scraper's schedule
const ScraperSchedule = {
    HOURLY: 'hourly',
    DAILY: 'daily',
    WEEKLY: 'weekly',
    MONTHLY: 'monthly'
}

// Rendering (static, dynamic, or auto)
const Rendering = {
    STATIC: 'static',
    DYNAMIC: 'dynamic',
    AUTO: 'auto'
}

// The type of feedback the user reported
const FeedbackType = {
    BUG_REPORT: 'bug_report',
    COMMENT: 'comment',
    FEATURE_REQUEST: 'feature_request'
}

// The status of a support ticket
const SupportTicketStatus = {
    ACTIVE: 'active',
    NEED_FEEDBACK: 'need_feedback',
    SOLVED: 'solved'
}

// The user's plan
const PlanType = {
    TRIAL: 'TRIAL',
    PAID: 'PAID'
}

// The plan's status
const PlanStatus = {
    // A custom plans is offered to the user
    OFFERED: 'OFFERED',

    // The plan is active so the user has access to the service
    ACTIVE: 'ACTIVE',

    // The free trial ended
    ENDED: 'ENDED',

    // The plan is suspended after a payment failure
    SUSPENDED: 'SUSPENDED',

    // The plan was cancelled by the user, but he can still renew it until the end of the billing period.
    CANCELLING: 'CANCELLING'
}

// The template's source (created by a user or it's pre-made by the platform)
const TemplateSource = {
    // Created by the user
    USER: 'USER',

    // Pre-made by the platform
    BUILT_IN: 'BUILT_IN'
}

// The log message
const LogMsg = {
    SESSION_STARTED: 'session_started',
    RENDERING_CHOSEN: 'rendering_chosen',
    URLS_LOADED_FROM_GS: 'urls_loaded_from_gs',
    PAGE_SCRAPED: 'page_scraped',
    PAGE_FAILED: 'page_failed',
    SCROLLED_DOWN: 'scrolled_down',
    CLICKED_ELEMENT: 'clicked_element',
    SESSION_COMPLETED: 'session_completed',
    SESSION_STOPPED: 'session_stopped',
    SESSION_FAILED: 'session_failed',
    GS_DATA_PUSHED: 'gs_data_pushed',
    GS_DATA_PUSH_FAILED: 'gs_data_push_failed',
    NOTIFY_EMAIL_SENT: 'notify_email_sent',
    NOTIFY_EMAIL_SEND_FAILED: 'notify_email_send_failed',
}

// The source of the input URLs
const InputUrlsSource = {
    LIST: 'list',
    GOOGLE_SHEET: 'google_sheet'
}

// The template type
const TemplateType = {
    TABLE: 'table',
    WORKFLOW: 'workflow'
}

// The output type
const OutputType = {
    GOOGLE_SHEET: 'google_sheet'
}

module.exports = {PLACEHOLDER_REGEX, SELECTOR_SEPARATOR_REGEX, UserRole, FieldType, PageLevel, ExportFormat, RequestType,
    PaginationMethod, ScraperStatus, ScraperRunStatus, ScraperSchedule, Rendering, FeedbackType, SupportTicketStatus, PlanType,
    PlanStatus, TemplateSource, LogMsg, InputUrlsSource, TemplateType, OutputType}